import React from 'react';
import { formatLocalTime } from '../Utils/dateUtils';

// The patient's last earlier result for the same test, returned by
// PrintReports as previousResult / previousResultDate. Templates add a
// "Previous" column only when at least one printed test has one.
// See docs/features/previous-results.
export const hasPreviousResults = (rows) =>
  Array.isArray(rows) && rows.some((r) => r?.previousResult);

const PreviousResult = ({ data }) => {
  if (!data?.previousResult) return <span style={{ color: '#94a3b8' }}>-</span>;

  return (
    <span>
      {data.previousResult}
      {data.previousResultDate && (
        <span style={{ display: 'block', fontSize: '0.8em', fontWeight: 'normal', color: '#64748b' }}>
          {formatLocalTime(data.previousResultDate, 'D MMM YY')}
        </span>
      )}
    </span>
  );
};

export default PreviousResult;
